import React from 'react'
import { useSelector } from 'react-redux'
import selectIsLogged from 'redux/selectors/selectIsLogged'
import AccordionHeader from 'components/accordion/StickyHeader'
import HamburgerContainer from 'redux/containers/components/layout/HamburgerContainer'
import LogoLinkContainer from 'redux/containers/components/layout/LogoLinkContainer'
import SearchContainer from 'redux/containers/components/layout/search/SearchContainer'
import DesktopLinksContainer from 'redux/containers/components/layout/DesktopLinksContainer'
import MenuContainer from 'redux/containers/components/layout/MenuContainer'
import HeaderAppendProxyContainer from 'redux/containers/components/layout/HeaderAppendProxyContainer'
import selectUrl from 'redux/selectors/selectUrl'
import SmartSearchSwitch from 'components/smartsearch/SmartSearchSwitch'

const Header = ({
  header: append,
  query,
  searchType,
  params,
  isNavigationVisible,
  isDesktopNavigationVisible
}) => {
  const isLogged = useSelector(selectIsLogged)

  return (
    <div id='application-header'>
      <div className='pb0-m pt5-m'>
        <MenuContainer />
        <div className='pv6 flex justify-between items-center layout-width-constraint'>
          <LogoLinkContainer className='flex grow-0 shrink-0 justify-start items-center mr9 mr6-m' />
          <SearchContainer
            className='basis-auto-t grow-5 shrink-1 justify-start relative mr6 mr3-m'
            {...{ query, params }}
          />
          {isLogged && (
            <div className='dn-t db smartsearch-switch'>
              <SmartSearchSwitch />
            </div>
          )}
          <HamburgerContainer {...{ isNavigationVisible }} dataAttributes={{ 'data-testid': 'mobile-menu-trigger' }} />
          <DesktopLinksContainer className='dn-t flex justify-end items-center grow-0 shrink-0' {...{ params }} />
        </div>
        <HeaderAppend {...{ append, searchType }} />
        <AccordionHeader />
      </div>
    </div>
  )
}

const HeaderAppend = ({ append, searchType }) => {
  const url = useSelector(selectUrl)

  return append || <HeaderAppendProxyContainer {...{ searchType, url }} />
}

export default Header
